import { LinkProps } from 'config/links';
import { SideLink } from './sidelink/sidelink';

export const SideLinks = ({ links }: { links: LinkProps[] }) => (
  <nav>
    <ul>
      {links.map((link) => (
        <SideLink key={link.label} link={link} />
      ))}
    </ul>
  </nav>
);
